module.exports = __webpack_public_path__ + "img/step2.f3f2dd73.svg";